import type { UUID } from '@kerberos-compliance/compliance-shared-ts/common/types/uuid.type';
import { AuthMethodProviderMap } from '@kerberos-compliance/compliance-shared-ts/core/iam/authentication/enums/auth-method-provider.enum';
import type { DeviceIdScope } from '@kerberos-compliance/compliance-shared-ts/core/iam/authentication/enums/device-id-scope.enum';
import { DeviceIdScopeMap } from '@kerberos-compliance/compliance-shared-ts/core/iam/authentication/enums/device-id-scope.enum';
import type { AdpJwtPayloadExtension } from '@kerberos-compliance/compliance-shared-ts/core/iam/authentication/types/jwt-payload.types';
import type { UserStatus, UserType } from '@kerberos-compliance/compliance-shared-ts/features/user/enums/user.enums';

export type ImpersonationSessionContext = {
  userId: UUID;
  displayName?: string | null;
  email?: string | null;
  userType: UserType;
  userStatus: UserStatus;
};

export type ImpersonationSessionState = ImpersonationSessionContext & {
  returnToken: string;
  startedAt: string;
};

export type ForceSignOutContext = {
  userId: UUID;
  displayName?: string;
  email: string;
  userStatus: UserStatus;
};

export const DeviceIdScopeLabelMap: Readonly<Record<DeviceIdScope, string>> = {
  [DeviceIdScopeMap.AmlDesk]: 'AML desk',
  [DeviceIdScopeMap.AmlAdminDesk]: 'AML admin desk',
  [DeviceIdScopeMap.ClientCredentials]: 'Client credentials',
  [DeviceIdScopeMap.OnOffice]: 'onOffice',
};

/**
 * Display names for the `asrc` (auth source) provider numbers a platform token can carry.
 */
export const AuthSourceLabelMap: Readonly<Partial<Record<number, string>>> = {
  [AuthMethodProviderMap.MsAzureADB2C]: 'Azure B2C',
  [AuthMethodProviderMap.MSAzureAD]: 'Entra ID',
  [AuthMethodProviderMap.Hanko]: 'Hanko',
};

/**
 * The device-cookie claims the DX panel reads from a platform token.
 */
export type DeviceCookieClaims = Pick<AdpJwtPayloadExtension, 'dids' | 'asrc'>;
